import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Explore")

import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import { startCase } from "lodash";
import AppTabs from "@/components/AppTabs.vue";
import NodeSearch from "./NodeSearch.vue";
import TextAnnotator from "./TextAnnotator.vue";
import PhenotypeExplorer from "./PhenotypeExplorer.vue";
import { appTitle } from "@/global/meta";
import tabs from "./tabs.json";

/** route info */

export default /*#__PURE__*/_defineComponent({
  __name: 'PageExplore',
  setup(__props) {

const route = useRoute();

/** selected tab */
const tab = ref(tabs[0].id);

/** update document title */
watch(
  () => route.fullPath,
  () => {
    if (route.hash) appTitle.value = [startCase(route.hash)];
  },
  { immediate: true, flush: "post" }
);

return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppSection = _resolveComponent("AppSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(AppTabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
          name: "Explore Mode",
          tabs: _unref(tabs)
        }, null, 8, ["modelValue", "tabs"])
      ]),
      _: 1
    }),
    (tab.value === 'node-search')
      ? (_openBlock(), _createBlock(NodeSearch, { key: 0 }))
      : _createCommentVNode("", true),
    (tab.value === 'text-annotator')
      ? (_openBlock(), _createBlock(TextAnnotator, { key: 1 }))
      : _createCommentVNode("", true),
    (tab.value === 'phenotype-explorer')
      ? (_openBlock(), _createBlock(PhenotypeExplorer, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})